const API_BASE = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3003'

const get = (path) => fetch(`${API_BASE}/${path}`)
    .then(async (r) => {
        let payload = null
        try {
            payload = await r.json()
        } catch (err) {
            payload = null
        }
        if (!r.ok) {
            const error = new Error(`HTTP ${r.status}`)
            error.status = r.status
            error.payload = payload
            throw error
        }
        return payload
    })
    // .catch(console.warn)
    // NOTE: needsto be disabled for offline handling
    // TODO: improve offline handling with service worker (eg. cache response instead of custom)

const post = (path, data) => {
    return fetch(`${API_BASE}/${path}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-type': 'application/json',
        },
    }).then(r => r.json())
    .catch(console.error)
}

const put = (path, data) => fetch(`${API_BASE}/${path}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
        'Content-type': 'application/json',
    },
}).then(async (r) => {
    let payload = null
    try {
        payload = await r.json()
    } catch (err) {
        payload = null
    }
    if (!r.ok) {
        const error = new Error(`HTTP ${r.status}`)
        error.status = r.status
        error.payload = payload
        throw error
    }
    return payload
})

export { get, post, put }
